import { ApolloConsumer } from "@apollo/client";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_ROLE,
  UPDATE_ROLE,
  CREATE_ROLE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { regexPatterns } from "@vocollege/app";
import { useStyles } from "./styles";

const initialState = {
  id: 0,
  name: "",
  label: "",
};

export default function RoleEdit() {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleRedirect = (state: any) => {
    navigate("/acl/roles");
  };

  return (
    <ApolloConsumer>
      {(client) => (
        <Layout>
          <Form
            client={client}
            tabs={[
              {
                key: "content",
                label: I18n.get.misc.content,
                fields: [
                  {
                    name: "name",
                    label: I18n.get.acl.labels.name,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                    },
                    validation: {
                      required: true,
                      pattern: {
                        value: regexPatterns.cleanName,
                        message: I18n.get.acl.errors.invalidName,
                      },
                    },
                  },
                  {
                    name: "label",
                    label: I18n.get.acl.labels.label,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                    },
                    validation: {
                      required: true,
                    },
                  },
                ],
              },
            ]}
            labels={{
              loading: I18n.get.form.labels.loadingContent,
              create: I18n.get.form.labels.createRole,
              created: I18n.get.queue.messages.queueSaved,
              updated: I18n.get.queue.messages.queueSaved,
              deleted: I18n.get.queue.messages.queueDeleted,
              fieldRequired: I18n.get.form.errors.required,
            }}
            operations={{
              category: "role",
              get: GET_ROLE,
              create: CREATE_ROLE,
              update: UPDATE_ROLE,
            }}
            initialState={initialState}
            pageTitleField="label"
            classes={{
              root: classes.root,
              paper: "vo-global__content-with-toolbar",
              toolbar: "vo-global__content-toolbar",
            }}
            onComplete={handleRedirect}
            onCancel={handleRedirect}
          />
        </Layout>
      )}
    </ApolloConsumer>
  );
}
